import React from "react";
import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";
import { RETAINER_PACKAGES, waLink } from "../data/content";
import { fadeUp, staggerContainer, viewportOnce, EYEBROW } from "../lib/motion";

export const Retainer = () => {
  return (
    <section id="retainer" data-testid="retainer-section" className="relative bg-navy py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 noise opacity-[0.06]" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="max-w-3xl"
        >
          <span className={EYEBROW}>Legal Retainer</span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl tracking-tight text-white leading-[1.05] font-bold">
            Pilih Paket <span className="italic text-gold">Pendampingan Hukum</span>
          </h2>
          <p className="mt-5 text-white/60 text-lg">
            Pendampingan hukum berkelanjutan bagi perusahaan tanpa harus memiliki divisi legal internal.
            Setiap paket disesuaikan lebih lanjut sesuai skala kebutuhan Anda.
          </p>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6 items-stretch"
        >
          {RETAINER_PACKAGES.map((p) => (
            <motion.div
              key={p.name}
              variants={fadeUp}
              data-testid={`retainer-${p.name}`}
              className={`relative flex flex-col rounded-3xl p-8 transition-all duration-400 hover:-translate-y-2 ${
                p.popular
                  ? "bg-gold text-navy shadow-gold lg:-mt-4 lg:mb-4"
                  : "bg-navy-light/60 border border-white/10 text-white hover:border-gold/40"
              }`}
            >
              {p.popular && (
                <span
                  data-testid="retainer-popular-badge"
                  className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-navy text-gold text-xs font-bold uppercase tracking-[0.15em] px-4 py-1.5"
                >
                  Populer
                </span>
              )}
              <h3 className={`font-serif text-3xl font-bold ${p.popular ? "text-navy" : "text-white"}`}>
                {p.name}
              </h3>
              <p className={`mt-2 text-sm leading-relaxed min-h-[3rem] ${p.popular ? "text-navy/80" : "text-white/60"}`}>
                {p.subtitle}
              </p>

              <ul className="mt-6 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className={`flex items-start gap-2.5 text-sm ${p.popular ? "text-navy/90" : "text-white/80"}`}>
                    <Check className={`h-4 w-4 mt-0.5 shrink-0 ${p.popular ? "text-navy" : "text-gold"}`} />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <p className={`mt-7 text-sm font-medium ${p.popular ? "text-navy/70" : "text-white/50"}`}>
                Hubungi Kami untuk Penawaran
              </p>
              <a
                href={waLink(`Halo FYLegal.ID, saya tertarik dengan Paket Legal Retainer ${p.name}. Mohon informasi penawarannya.`)}
                target="_blank"
                rel="noreferrer"
                data-testid={`retainer-cta-${p.name}`}
                className={`mt-3 inline-flex items-center justify-center rounded-full px-6 py-3.5 text-sm font-semibold transition-all duration-300 ${
                  p.popular
                    ? "bg-navy text-white hover:bg-navy-light"
                    : "bg-gold text-navy hover:bg-gold-light"
                }`}
              >
                Pilih Paket
              </a>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export const StarRow = ({ count }) => (
  <div className="flex gap-1">
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} className="h-5 w-5 fill-gold text-gold" />
    ))}
  </div>
);
